import { FunctionComponent } from "react";
import { useBreakpoint } from "@Hooks/useBreakpoint";
import { ProductInfosData, Section, Tile } from "@Types/pagify";
import { ProductDetails } from "./ProductDetails";
import { ProductHeader } from "./ProductHeader";
import { ProductImagesCarousel } from "./ProductImagesCarousel";
import { ProductImagesGallery } from "./ProductImagesGallery";
import "./style.scss";

export const ProductInfos: FunctionComponent<{
  imageListTiles: Tile[];
  productInfosData: ProductInfosData;
  productInfosSection: Section;
  productInfosTiles: Tile[];
}> = ({ imageListTiles, productInfosData, productInfosSection, productInfosTiles }) => {
  const { isLargeScreen } = useBreakpoint();

  return (
    <div className="ProductInfos">
      {isLargeScreen ? (
        <div className="ProductInfos-largeScreen">
          <ProductImagesGallery section={productInfosSection} tiles={imageListTiles} />
          <div className="ProductInfos-largeScreen-right">
            <ProductHeader section={productInfosSection} />
            <ProductDetails
              productInfosData={productInfosData}
              section={productInfosSection}
              tiles={productInfosTiles}
            />
          </div>
        </div>
      ) : (
        <>
          <ProductHeader section={productInfosSection} />
          <ProductImagesCarousel section={productInfosSection} tiles={imageListTiles} />
          <ProductDetails
            productInfosData={productInfosData}
            section={productInfosSection}
            tiles={productInfosTiles}
          />
        </>
      )}
    </div>
  );
};
